import { SelectValue } from '../model/interface/helper';

export const MONTH_OPTIONS = [
  {
    name: 'Январь',
    value: 1,
  },
  {
    name: 'Февраль',
    value: 2,
  },
  {
    name: 'Март',
    value: 3,
  },
  {
    name: 'Апрель',
    value: 4,
  },
  {
    name: 'Май',
    value: 5,
  },
  {
    name: 'Июнь',
    value: 6,
  },
  {
    name: 'Июль',
    value: 7,
  },
  {
    name: 'Август',
    value: 8,
  },
  {
    name: 'Сентябрь',
    value: 9,
  },
  {
    name: 'Октябрь',
    value: 10,
  },
  {
    name: 'Ноябрь',
    value: 11,
  },
  {
    name: 'Декабрь',
    value: 12,
  },
];

export const MONTH_OPTIONS_LOCALIZATION = [
  {
    name: 'MONTH',
    value: 1,
  },
  {
    name: 'MONTH',
    value: 2,
  },
  {
    name: 'MONTH',
    value: 3,
  },
  {
    name: 'MONTH',
    value: 4,
  },
  {
    name: 'MONTH',
    value: 5,
  },
];

export const WEEK_OPTIONS_LOCALIZATION = [
  {
    name: 'WEEK',
    value: 1,
  },
  {
    name: 'WEEK',
    value: 2,
  },
  {
    name: 'WEEK',
    value: 3,
  },
  {
    name: 'WEEK',
    value: 4,
  },
];

export const LESSON_TYPE_OPTIONS = [
  { name: 'QUIZ', value: 'QUIZ' },
  { name: 'TASK', value: 'TASK' },
  { name: 'LECTURE', value: 'LECTURE' },
  { name: 'TEXT', value: 'TEXT' },
  { name: 'ORAL', value: 'ORAL' },
];

export const EMPTY_VALUE: string = '—';
export const EMPTY_SELECT_VALUE: SelectValue = {
  name: EMPTY_VALUE,
  value: EMPTY_VALUE,
};

export const ADMIN_TABLE_SIZE: number = 10;

export const ROLES_OPTIONS = [
  {
    name: 'Студенты',
    value: 'STUDENT',
  },
  {
    name: 'Методисты',
    value: 'METHODIST',
  },
  {
    name: 'Кураторы',
    value: 'CURATOR',
  },
  {
    name: 'Завучи',
    value: 'HEAD_TEACHER',
  },
  {
    name: 'Преподаватель',
    value: 'TEACHER',
  },
  {
    name: 'Менеджер',
    value: 'MANAGER',
  },
];

export const ACTIVITY_OPTIONS = [
  // {
  //   name: 'Выбрать все',
  //   value: 'ALL',
  // },
  {
    name: 'ACTIVE',
    value: 'ACTIVE',
  },
  {
    name: 'PENDING',
    value: 'PENDING',
  },
  {
    name: 'ARCHIVED',
    value: 'ARCHIVED',
  },
];

export const MANAGERS_OPTIONS = [
  {
    name: 'EXTERNAL_MANAGERS',
    value: 'MANAGER',
  },
  {
    name: 'INTERNAL_MANAGERS',
    value: 'INTERNAL_MANAGER',
  },
];

export type StreamType =
  | 'SMART'
  | 'GENIUS'
  | 'JUNIOR'
  | 'INTENSIVE'
  | 'EXPRESS'
  | 'VIP'
  | 'PREMIUM'
  | 'STANDARD'
  | 'VIP_PRO'
  | 'PREMIUM_PRO'
  | 'STANDARD_PRO'
  | 'PAKET'
  | 'COMMUNITY'
  | 'IELTS'
  | 'TURBO'
  | 'OTHER';

export const STREAM_TYPES: Record<StreamType, StreamType> = {
  SMART: 'SMART',
  GENIUS: 'GENIUS',
  JUNIOR: 'JUNIOR',
  INTENSIVE: 'INTENSIVE',
  EXPRESS: 'EXPRESS',
  VIP: 'VIP',
  PREMIUM: 'PREMIUM',
  STANDARD: 'STANDARD',
  VIP_PRO: 'VIP_PRO',
  PREMIUM_PRO: 'PREMIUM_PRO',
  STANDARD_PRO: 'STANDARD_PRO',
  PAKET: 'PAKET',
  COMMUNITY: 'COMMUNITY',
  IELTS: 'IELTS',
  TURBO: 'TURBO',
  OTHER: 'OTHER',
} as const;

export type GoalType =
  | 'OTHER'
  | 'ENTER_DREAM_UNIVERSITY'
  | 'PERSONAL_GROWTH'
  | 'MASTER_SUBJECTS_PURPOSEFULLY'
  | 'HIGH_SCORE_AND_GRANT'
  | 'SYSTEMATIC_PREPARATION_FOR_140'
  | 'FINISH_COURSE_AND_PARTICIPATE'
  | 'IMPROVE_WEAK_AREAS';

export const GOAL_TYPES: Record<GoalType, GoalType> = {
  OTHER: 'OTHER',
  ENTER_DREAM_UNIVERSITY: 'ENTER_DREAM_UNIVERSITY',
  PERSONAL_GROWTH: 'PERSONAL_GROWTH',
  MASTER_SUBJECTS_PURPOSEFULLY: 'MASTER_SUBJECTS_PURPOSEFULLY',
  HIGH_SCORE_AND_GRANT: 'HIGH_SCORE_AND_GRANT',
  SYSTEMATIC_PREPARATION_FOR_140: 'SYSTEMATIC_PREPARATION_FOR_140',
  FINISH_COURSE_AND_PARTICIPATE: 'FINISH_COURSE_AND_PARTICIPATE',
  IMPROVE_WEAK_AREAS: 'IMPROVE_WEAK_AREAS',
} as const;

export const GOAL_OPTIONS: SelectValue<GoalType>[] = [
  {
    name: GOAL_TYPES.HIGH_SCORE_AND_GRANT,
    value: GOAL_TYPES.HIGH_SCORE_AND_GRANT,
  },
  {
    name: GOAL_TYPES.SYSTEMATIC_PREPARATION_FOR_140,
    value: GOAL_TYPES.SYSTEMATIC_PREPARATION_FOR_140,
  },
  { name: GOAL_TYPES.IMPROVE_WEAK_AREAS, value: GOAL_TYPES.IMPROVE_WEAK_AREAS },
  {
    name: GOAL_TYPES.MASTER_SUBJECTS_PURPOSEFULLY,
    value: GOAL_TYPES.MASTER_SUBJECTS_PURPOSEFULLY,
  },
  {
    name: GOAL_TYPES.FINISH_COURSE_AND_PARTICIPATE,
    value: GOAL_TYPES.FINISH_COURSE_AND_PARTICIPATE,
  },
  { name: GOAL_TYPES.PERSONAL_GROWTH, value: GOAL_TYPES.PERSONAL_GROWTH },
  {
    name: GOAL_TYPES.ENTER_DREAM_UNIVERSITY,
    value: GOAL_TYPES.ENTER_DREAM_UNIVERSITY,
  },
  { name: GOAL_TYPES.OTHER, value: GOAL_TYPES.OTHER },
];

export const WEBVIEW_STORAGE_KEY = 'mobile_app';

export const PERCENT_TO_ALLOW_SHOW_RATE_MODAL: number = 0.85;
